import React, {Component, Fragment} from "react";

import {WorkUnitInvocationLog} from "../models/WorkUnitInvocationLog";
import moment from "moment";
import {FRIENDLY_DATETIME_FORMAT} from "../utils/Utils";
import {connect} from "react-redux";
import {IRootState} from "../store";
import ApiService from "./ApiService";
import {Link} from "react-router-dom";
import {Icon} from "office-ui-fabric-react";

interface WorkUnitInvocationLogListProps
{
    tenantId: string;
    schoolCode: string;
    workUnitInvocationLogs: WorkUnitInvocationLog[];
    title: string;
    enableLinks: boolean;
    apiService: ApiService;
}

interface WorkUnitInvocationLogListState
{

}

class WorkUnitInvocationLogList extends Component<WorkUnitInvocationLogListProps,WorkUnitInvocationLogListState>
{
    public componentDidMount() {

    }
    
    private buildRow(workUnitInvocationLog: WorkUnitInvocationLog) : JSX.Element {

        let pillColour: string = "";

        switch (workUnitInvocationLog.resultCode) {
            case "Success":
                pillColour = "green";
                break;
            case "PartialSuccess":
                pillColour = "amber";
                break;
            case "Fail":
                pillColour = "red";
                break;
            default:
                pillColour = "grey";
                break;
        }
        
        const statusString = workUnitInvocationLog.resultCode === null ? "Unknown" : workUnitInvocationLog.resultCode;
        
        const createdAtMoment = moment(workUnitInvocationLog.createdAt);
        
        let updatedAtFromNow = "";
        let updatedAtFormatted = "";
        
        let duration = null;
        if(workUnitInvocationLog.updatedAt !== null)
        {
            const updatedAtMoment = moment(workUnitInvocationLog.updatedAt!);

            updatedAtFromNow = moment(updatedAtMoment).fromNow();
            updatedAtFormatted = moment(updatedAtMoment).format(FRIENDLY_DATETIME_FORMAT);
            
            const diff = updatedAtMoment.diff(createdAtMoment);
            const durationMoment = moment.duration(diff);
            duration = (
                <Fragment>
                    <span>{durationMoment.humanize()}</span>
                    <span className={"cdb-table__extra-detail"}>{durationMoment.minutes().toString().padStart(2,"0")}:{durationMoment.seconds().toString().padStart(2,"0")}</span>
                </Fragment>
            );

        }
        
        const resourcesLinks: JSX.Element[] = [];
        if(workUnitInvocationLog.resourceLinks)
        {
            workUnitInvocationLog.resourceLinks.forEach(resourceLink=>{
                const icon = resourceLink.type === "site" ? "SharePointLogo" : "Group";
                resourcesLinks.push(<Link to={`/cdb-admin/explorer/${this.props.tenantId}/${this.props.schoolCode}/${resourceLink.type}/${resourceLink.id}`} target={"_blank"}><Icon iconName={icon} className={"m-right-05rem"}/>{resourceLink.friendlyName}</Link>)
            });
        }
        
        const row = (
            <div className="cdb-table__row" key={workUnitInvocationLog.invocationId}>
                <div className="cdb-table__cell flex-item--flex-2 flex-column">
                    {workUnitInvocationLog.workUnitName}
                    <span className="cdb-table__extra-detail">{workUnitInvocationLog.invocationId}</span>
                </div>
                <div className="cdb-table__cell flex-item--flex-1 flex-column">{moment(workUnitInvocationLog.createdAt).fromNow()}
                    <span className="cdb-table__extra-detail">{createdAtMoment.format(FRIENDLY_DATETIME_FORMAT)}</span>
                </div>
                <div className="cdb-table__cell flex-item--flex-1 flex-column">{updatedAtFromNow}
                    <span className="cdb-table__extra-detail">{updatedAtFormatted}</span>
                </div>
                <div className={"cdb-table__cell flex-item--flex-1"}>
                    {workUnitInvocationLog.resultCode == null ? null : duration}
                </div>
                <div className="cdb-table__cell flex-item--flex-4">{workUnitInvocationLog.resultMessage}</div>
                <div className="cdb-table__cell flex-item--flex-4">{resourcesLinks}</div>
                <div className="cdb-table__cell flex-item--flex-1">
                    <span className={`pill pill--${pillColour}`}>{statusString}</span>
                </div>
            </div>
        );
        
        
        if(this.props.enableLinks)
        {
            return (
                <Link to={`/cdb-admin/workloads/${workUnitInvocationLog.parentWorkloadInstanceId}/${workUnitInvocationLog.invocationId}/logs`} key={workUnitInvocationLog.invocationId}>
                    {row}
                </Link>
            );
        }
        else
        {
            return row;
        }
    }

    public render() {

        const rows = this.props.workUnitInvocationLogs.sort((a,b) => a.createdAt > b.createdAt ? 1 : -1).map((workUnitInvocationLog) => this.buildRow(workUnitInvocationLog));
        
        return (
            <div className="cdb-table">
    
                <div className="card__header">
                    <span className={"card__title"}>{this.props.title}</span>
                </div>
    
                <div className="cdb-table__row cdb-table__row--header">
                    <div className="cdb-table__cell flex-item--flex-2">Name</div>
                    <div className="cdb-table__cell flex-item--flex-1">Created</div>
                    <div className="cdb-table__cell flex-item--flex-1">Updated</div>
                    <div className="cdb-table__cell flex-item--flex-1">Duration</div>
                    <div className="cdb-table__cell flex-item--flex-4">Result Message</div>
                    <div className="cdb-table__cell flex-item--flex-4">Resource Links (preview)</div>
                    <div className="cdb-table__cell flex-item--flex-1">Status</div>
                </div>
                {rows}
            </div>
        );
    }
}

export default connect(
    (state: IRootState,ownProps: {workUnitInvocationLogs: WorkUnitInvocationLog[], title: string,enableLinks: boolean,tenantId:string,schoolCode:string}): WorkUnitInvocationLogListProps => {
        return {
            tenantId: ownProps.tenantId,
            schoolCode: ownProps.schoolCode,
            workUnitInvocationLogs: ownProps.workUnitInvocationLogs,
            title: ownProps.title,
            enableLinks: ownProps.enableLinks,
            apiService: state.auth.apiService,
        };
    }
)(WorkUnitInvocationLogList)